// Options for the optional "How did you hear about us?" question.
// Stored separately from the tracked visit source (referrer/UTM) so the two are never mixed.
export const HEARD_ABOUT_OPTIONS = ['ChatGPT', 'Gemini', 'Claude', 'Perplexity', 'Copilot', 'Google Search', 'Bing Search', 'Social media', 'Referral from someone', 'Other', 'Not sure'];

export const AI_HEARD_ABOUT = ['ChatGPT', 'Gemini', 'Claude', 'Perplexity', 'Copilot'];